import { render } from "./Navigation.vue?vue&type=template&id=1ff338c1&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1ff338c1"

export default script